import { useCallback } from 'react';
import { LinkId } from '../../../../../common/AnalyticsContext/LinkId';
import { applyTrackingId } from '../../../../../common/AnalyticsContext/applyTrackingId';
import { returnVoid } from '../../../../../common/util/returnVoid';
import { safeMemo } from '../../../../../common/util/safeMemo';
import { Option } from '../RadioGroup';
import {
  InputWrapper,
  RadioUncheckedTeal,
  RadioCheckedTeal,
  RadioLabel,
  NinjaInput,
  LabelContainer,
  RadioDescription,
  RadioCheckedTealFullFill,
} from './RadioOption.styles';

interface Props<T> {
  readonly option: Option<T>;
  readonly selected: boolean;
  readonly groupName: string;
  readonly onClick: Setter<T>;
  /** display options in rows (2 in a row) */
  readonly row?: boolean;
  readonly trackingId?: LinkId;
  className?: string;
  readonly fullPricingExperiment?: boolean;
}

export const RadioOption = safeMemo(
  <T,>({
    option,
    selected,
    onClick,
    groupName,
    row,
    trackingId,
    className,
    fullPricingExperiment,
  }: Props<T>) => {
    const handleClick = useCallback(() => onClick(option.value), [onClick, option.value]);

    return (
      <InputWrapper
        onClick={handleClick}
        row={row}
        selected={selected}
        className={className}
        {...applyTrackingId(trackingId)}
      >
        <NinjaInput
          value={String(option.value)}
          type="radio"
          name={groupName}
          checked={selected}
          onChange={returnVoid}
        />
        {selected && fullPricingExperiment && (
          <RadioCheckedTealFullFill name="RadioChecked" checked />
        )}
        {selected && !fullPricingExperiment && <RadioCheckedTeal name="RadioChecked" checked />}
        {!selected && <RadioUncheckedTeal />}
        <LabelContainer>
          <RadioLabel selected={selected}>{option.label}</RadioLabel>
          {option.description && <RadioDescription>{option.description}</RadioDescription>}
        </LabelContainer>
      </InputWrapper>
    );
  },
);
